import { type BasicCouponFragment, type CompleteStoreFragment, type Maybe } from '@drycut/graphql';
import { type DateTime } from 'luxon';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type CheckoutState = {
  manual: boolean;
  scheduled: boolean;
  selectedCoupon?: BasicCouponFragment;
  selectedSchedule?: DateTime;
  selectedStore?: Maybe<CompleteStoreFragment>;
};

type CheckoutActions = {
  setSelectedCoupon: (coupon?: BasicCouponFragment) => void;
  setSelectedSchedule: (date?: DateTime) => void;
  setSelectedStore: (store: CompleteStoreFragment) => void;
  toggleScheduled: () => void;
};

export const useCheckoutStore = create<CheckoutState & CheckoutActions>()(
  devtools((set): CheckoutState & CheckoutActions => {
    return {
      // State
      manual: false,
      selectedStore: undefined,
      scheduled: false,
      selectedSchedule: undefined,
      selectedCoupon: undefined,

      setSelectedStore: (store) => {
        set({ selectedStore: store }, undefined, 'setSelectedStore');
      },

      toggleScheduled: () => {
        // Using the value from useBoolean hook
        set((state) => ({ scheduled: !state.scheduled }), undefined, 'toggleScheduled');
      },

      setSelectedSchedule: (date) => {
        set({ selectedSchedule: date, scheduled: Boolean(date) }, undefined, 'setSelectedSchedule');
      },

      setSelectedCoupon: (coupon) => {
        set({ selectedCoupon: coupon }, undefined, 'setSelectedCoupon');
      },
    };
  }),
);
